module.exports = __webpack_public_path__ + "img/liuyan_bg.1656f070.png";